import { useMemo } from 'react';

import type { PaymentMethod } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

import type { CreditCardOption } from '../../Checkout.utils';

export function useCreditCardOptions(paymentMethods: readonly PaymentMethod[]) {
  const { t } = useLocalizationContext();
  const newCardLabel = t('checkout.add-card');

  const creditCardOptions: readonly CreditCardOption[] = useMemo(
    () => [
      {
        value: 'ADD',
        label: newCardLabel,
        cardType: 'NEW',
        paymentMethodType: 'BillingAccount',
        isDefault: false,
      },
      ...(paymentMethods.map((paymentMethod) => ({
        value: paymentMethod.id,
        label: getPaymentMethodLabel(paymentMethod),
        cardType: paymentMethod.cardType,
        isDefault: paymentMethod.isDefault,
        paymentMethodType: paymentMethod.__typename ?? 'BillingAccount',
      })) ?? []),
    ],
    [paymentMethods, newCardLabel],
  );

  return { creditCardOptions };
}

function getPaymentMethodLabel(paymentMethod: PaymentMethod) {
  if (paymentMethod.nickname) {
    return `${paymentMethod.nickname} - ${paymentMethod.description}`;
  }

  return paymentMethod.description ?? '';
}
